import React from "react";
import ProjectsLaunched from "../components/home/ProjectsGallery";
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ProjectsPage = () => {
  return (
    <div>
      <Navbar />
    <div style={{ paddingTop: "100px" }}>
      <ProjectsLaunched />
    </div>
    <Footer />
    </div>
  );
};

export default ProjectsPage;
